function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Label from '../Label';
import { getValidElementProps } from '../utils/htmlValidProps';
import Icon from '../Icon';

require('xps-style/core/input.css');

var propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,

  /** Placeholder for input field. Recommended to not use placeholder on desktop except a date and select field.  */
  placeholder: PropTypes.string,

  /** Add Label component above the input field */
  label: PropTypes.string,

  /** Display label inside the input container/element */
  inlineLabel: PropTypes.bool,

  /** Size (height) of the input controls (small: 32px, medium: 40px, large: 48px) */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /** Show icon on the right side */
  icon: PropTypes.string,

  /** classname for the icon */
  iconClassName: PropTypes.string,

  /** callback function on clicking the icon */
  onIconClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Put error description below the input field in red */
  error: PropTypes.string,
  lblRequired: PropTypes.bool,

  /** Put description below the input field */
  description: PropTypes.string,
  search: PropTypes.bool,
  type: PropTypes.string,
  onChangeValue: PropTypes.func,
  maxlength: PropTypes.number,
  autoComplete: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),

  /** Toggle disabled state of the Input */
  disabled: PropTypes.bool,

  /** Display optional next to the label */
  optional: PropTypes.bool,

  /** Remove margin top above the input label */
  removeMarginTop: PropTypes.bool
};
var defaultProps = {
  type: 'text',
  onChangeValue: function onChangeValue() {},
  autoComplete: true,
  size: 'small',
  inlineLabel: false
};

var Input = /*#__PURE__*/function (_Component) {
  _inherits(Input, _Component);

  var _super = _createSuper(Input);

  function Input() {
    var _this;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "focusInlineInput", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          id = _this$props.id,
          name = _this$props.name;

      if (!disabled) {
        _this["".concat(id || name, "-inlineInput")].focus();
      }
    });

    return _this;
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _cx,
          _cx2,
          _cx3,
          _cx4,
          _this2 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          name = _this$props2.name,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder,
          label = _this$props2.label,
          inlineLabel = _this$props2.inlineLabel,
          size = _this$props2.size,
          icon = _this$props2.icon,
          iconClassName = _this$props2.iconClassName,
          onIconClick = _this$props2.onIconClick,
          value = _this$props2.value,
          lblRequired = _this$props2.lblRequired,
          description = _this$props2.description,
          error = _this$props2.error,
          search = _this$props2.search,
          onChangeValue = _this$props2.onChangeValue,
          maxlength = _this$props2.maxlength,
          autoComplete = _this$props2.autoComplete,
          disabled = _this$props2.disabled,
          optional = _this$props2.optional,
          removeMarginTop = _this$props2.removeMarginTop;
      var labelId = id || name;

      var inputAdaProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        'aria-invalid': !!error
      }, !inlineLabel && {
        'aria-required': lblRequired
      }), description && {
        'aria-describedby': "".concat(labelId, "__description")
      }), error && {
        'aria-describedby': "".concat(labelId, "__error")
      }), !label && placeholder && {
        'aria-label': placeholder
      });

      var validDivAdaProps = getValidElementProps('div', inputAdaProps);
      var componentProps = getValidElementProps('input', this.props);

      var inputProps = _objectSpread(_objectSpread({}, componentProps), inputAdaProps);

      var ntClass = cx((_cx = {}, _defineProperty(_cx, "input__field input--".concat(size), true), _defineProperty(_cx, "input__search", search), _defineProperty(_cx, 'input-skin', !error), _defineProperty(_cx, 'input-skin--error', error), _defineProperty(_cx, 'input-skin--icon', icon), _defineProperty(_cx, 'input__placeholder--no-label', !label), _cx));
      var iconClass = cx((_cx2 = {
        input__icon: true
      }, _defineProperty(_cx2, "input__icon-".concat(size), true), _defineProperty(_cx2, 'input__icon-error', error), _defineProperty(_cx2, 'input__icon-search', search), _defineProperty(_cx2, 'opacity-50p', disabled), _defineProperty(_cx2, 'cursor-not-allowed', disabled), _defineProperty(_cx2, 'cursor-pointer', onIconClick), _defineProperty(_cx2, iconClassName, iconClassName), _cx2));
      var descClass = cx({
        input__info: true,
        'color-text': true,
        'opacity-50p': disabled,
        'cursor-not-allowed': disabled
      });
      var errorClass = cx({
        input__info: true,
        'color-text--error': true
      });
      var lblClass = cx({
        'input__label-required__container': true,
        'input__label--no-margintop': removeMarginTop,
        'opacity-50p': disabled
      });
      var inlineLabelInputContainer = cx((_cx3 = {
        'input-container': !error,
        'input-container--error': error,
        'align-items-center': true
      }, _defineProperty(_cx3, "height-".concat(size), true), _defineProperty(_cx3, 'paddingright-md paddingleft-md', size !== 'large'), _defineProperty(_cx3, 'paddingright-lg paddingleft-lg', size === 'large'), _defineProperty(_cx3, 'cursor-pointer', !disabled), _defineProperty(_cx3, 'opacity-50p', disabled), _defineProperty(_cx3, 'cursor-not-allowed', disabled), _defineProperty(_cx3, 'input-skin--disabled', disabled), _defineProperty(_cx3, 'input-skin--error', error), _cx3));
      var inlineLabelClass = cx({
        'input__label--inline': true,
        'display-inlineblock': true,
        'paddingright-md': true,
        'whitespace-nowrap': true,
        'cursor-pointer': !disabled,
        'cursor-not-allowed': disabled,
        'opacity-100p': disabled,
        'input-skin--disabled': disabled
      });
      var inlineInputClass = cx({
        input__search: search,
        'input-skin--noborder': true,
        'input-skin--inline-icon': icon,
        'input__placeholder--no-label': !label,
        'cursor-text': !disabled,
        'opacity-100p': disabled,
        'input-skin--disabled': disabled,
        'cursor-not-allowed': disabled,
        'margin-none': true,
        'paddingtop-none': true,
        'paddingbottom-none': true,
        'paddingleft-none': true,
        'border-none': true,
        'flex-grow-2': true
      });
      var inlineIconClass = cx((_cx4 = {
        input__icon: true
      }, _defineProperty(_cx4, "input__icon-".concat(size), true), _defineProperty(_cx4, 'margin-none', true), _defineProperty(_cx4, 'cursor-pointer', !disabled), _defineProperty(_cx4, 'opacity-50p', disabled), _defineProperty(_cx4, 'input-skin--disabled', disabled), _defineProperty(_cx4, 'cursor-not-allowed', disabled), _defineProperty(_cx4, 'input__icon-search', search), _defineProperty(_cx4, 'input__icon-error', error), _defineProperty(_cx4, 'icon--error', error), _defineProperty(_cx4, iconClassName, iconClassName), _cx4));
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        className: lblClass
      }, label !== undefined && !inlineLabel ? /*#__PURE__*/React.createElement(Label, {
        name: labelId,
        text: label,
        className: "input__label",
        optional: !lblRequired && optional
      }) : null, lblRequired ? /*#__PURE__*/React.createElement("span", {
        className: "input__label-required font-sm align-self-end"
      }, "Required") : null), inlineLabel ? /*#__PURE__*/React.createElement("div", _extends({
        className: inlineLabelInputContainer,
        role: "presentation",
        "aria-haspopup": "listbox",
        onKeyDown: this.focusInlineInput,
        onClick: this.focusInlineInput
      }, validDivAdaProps), /*#__PURE__*/React.createElement(Label, {
        className: inlineLabelClass,
        style: size === 'large' ? {
          fontSize: 15
        } : null,
        text: label
      }), /*#__PURE__*/React.createElement("input", _extends({
        id: "".concat(labelId, "-inlineInput"),
        className: inlineInputClass,
        value: value,
        onChange: onChangeValue,
        maxLength: maxlength,
        "aria-label": label
      }, componentProps, {
        autoComplete: autoComplete && autoComplete !== 'off' ? 'on' : 'off',
        ref: function ref(_ref) {
          _this2["".concat(labelId, "-inlineInput")] = _ref;
        }
      })), icon ? /*#__PURE__*/React.createElement(Icon, _extends({
        className: inlineIconClass,
        name: icon
      }, onIconClick && {
        onClick: onIconClick
      })) : null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", _extends({
        "aria-label": label,
        id: "".concat(labelId),
        className: ntClass,
        value: value,
        onChange: onChangeValue,
        maxLength: maxlength
      }, inputProps, {
        autoComplete: autoComplete && autoComplete !== 'off' ? 'on' : 'off',
        ref: function ref(_ref2) {
          _this2["".concat(labelId)] = _ref2;
        }
      })), icon ? /*#__PURE__*/React.createElement(Icon, _extends({
        className: iconClass,
        name: icon
      }, onIconClick && {
        onClick: onIconClick
      })) : null), error && /*#__PURE__*/React.createElement("div", {
        role: "alert",
        className: errorClass,
        id: "".concat(labelId, "__error")
      }, error), description && !error && /*#__PURE__*/React.createElement("div", {
        id: "".concat(labelId, "__description"),
        className: descClass
      }, description));
    }
  }]);

  return Input;
}(Component);

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
Input.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "focusInlineInput",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Input",
  "props": {
    "type": {
      "defaultValue": {
        "value": "'text'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onChangeValue": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "autoComplete": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "bool"
        }]
      },
      "required": false,
      "description": ""
    },
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Size (height) of the input controls (small: 32px, medium: 40px, large: 48px)"
    },
    "inlineLabel": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display label inside the input container/element"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder for input field. Recommended to not use placeholder on desktop except a date and select field."
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Add Label component above the input field"
    },
    "icon": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Show icon on the right side"
    },
    "iconClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "classname for the icon"
    },
    "onIconClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "callback function on clicking the icon"
    },
    "value": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": ""
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Put error description below the input field in red"
    },
    "lblRequired": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Put description below the input field"
    },
    "search": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "maxlength": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Toggle disabled state of the Input"
    },
    "optional": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display optional next to the label"
    },
    "removeMarginTop": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Remove margin top above the input label"
    }
  }
};
export default Input;